import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface AppModalProps {
  isOpen: boolean
  title?: string
  onClose: () => void
  children: ReactNode
  maxWidth?: number
  closeOnOverlayClick?: boolean
}

export const AppModal = ({
  isOpen,
  title,
  onClose,
  children,
  maxWidth = 600,
  closeOnOverlayClick = false,
}: AppModalProps) => {
  if (!isOpen) {
    return null
  }

  return createPortal(
    <div
      className="app-modal-overlay"
      onClick={closeOnOverlayClick ? onClose : undefined}
      role="presentation"
    >
      <div
        className="app-modal"
        style={{ maxWidth: `${maxWidth}px` }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {title && <h3 className="app-modal__title">{title}</h3>}
        <div className="app-modal__body">{children}</div>
      </div>
    </div>,
    document.body
  )
}

